import { i18n } from '@/plugins/i18n'
import { applicationStatusStr, applicationStatusVariant } from '@/constants/applicationStatus'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('application.title'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = applicationStatusStr.get(row.status)
            let variant = 'badge-'+applicationStatusVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 80
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    }
]